// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zoom-controls-bottom {
  position: fixed;
  bottom: 5px;
  right: 15px;
  z-index: 10000;
  background: #fff;
  padding: 2px 4px;
  display: none;
}
.zoom-controls-bottom .zoom-controls-container {
  display: flex;
  align-items: center;
  gap: 5px;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn {
  width: 22px;
  height: 22px;
  border: 1px solid #ccc;
  background: #fff;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  transition: background 0.15s ease;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn:hover:not(:disabled) {
  background: #f5f5f5;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.zoom-controls-bottom .zoom-controls-container .zoom-btn i {
  font-size: 9px;
}
.zoom-controls-bottom .zoom-controls-container .fit-screen i {
  font-size: 10px;
}
.zoom-controls-bottom .zoom-controls-container .zoom-slider {
  appearance: none;
  width: 90px;
  height: 1px;
  background: #ccc;
  outline: none;
  cursor: pointer;
}
.zoom-controls-bottom .zoom-controls-container .zoom-slider::-webkit-slider-thumb {
  appearance: none;
  width: 10px;
  height: 10px;
  background: #666;
  cursor: pointer;
}
.zoom-controls-bottom .zoom-controls-container .zoom-slider::-moz-range-thumb {
  width: 10px;
  height: 10px;
  background: #666;
  cursor: pointer;
  border: none;
}
.zoom-controls-bottom .zoom-controls-container .zoom-percentage {
  font-size: 11px;
  color: #333;
  min-width: 32px;
  text-align: left;
}

@media (max-width: 768px) {
  .zoom-controls-bottom {
    bottom: 5px;
    right: 10px;
  }
  .zoom-controls-bottom .zoom-controls-container {
    gap: 4px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-btn {
    width: 20px;
    height: 20px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-btn i {
    font-size: 8px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-slider {
    width: 70px;
  }
  .zoom-controls-bottom .zoom-controls-container .zoom-percentage {
    font-size: 10px;
    min-width: 28px;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/ZoomControls.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;AACN;AACM;EACE,mBAAA;AACR;AAEM;EACE,YAAA;EACA,mBAAA;AAAR;AAGM;EACE,cAAA;AADR;AAMM;EACE,eAAA;AAJR;AAQI;EAEE,gBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AANN;AAQM;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AANR;AASM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAPR;AAWI;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AATN;;AAeA;EACE;IACE,WAAA;IACA,WAAA;EAZF;EAcE;IACE,QAAA;EAZJ;EAcI;IACE,WAAA;IACA,YAAA;EAZN;EAcM;IACE,cAAA;EAZR;EAgBI;IACE,WAAA;EAdN;EAiBI;IACE,eAAA;IACA,eAAA;EAfN;AACF","sourcesContent":[".zoom-controls-bottom {\n  position: fixed;\n  bottom: 5px; // Position on the footer\n  right: 15px;\n  z-index: 10000; // Higher than footer's z-index: 3\n  background: #fff; // White background to be visible on footer\n  padding: 2px 4px;\n  display:none;\n\n  .zoom-controls-container {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n\n    .zoom-btn {\n      width: 22px;\n      height: 22px;\n      border: 1px solid #ccc;\n      background: #fff;\n      color: #333;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 11px;\n      transition: background 0.15s ease;\n\n      &:hover:not(:disabled) {\n        background: #f5f5f5;\n      }\n\n      &:disabled {\n        opacity: 0.3;\n        cursor: not-allowed;\n      }\n\n      i {\n        font-size: 9px;\n      }\n    }\n\n    .fit-screen {\n      i {\n        font-size: 10px;\n      }\n    }\n\n    .zoom-slider {\n      -webkit-appearance: none;\n      appearance: none;\n      width: 90px;\n      height: 1px;\n      background: #ccc;\n      outline: none;\n      cursor: pointer;\n\n      &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        appearance: none;\n        width: 10px;\n        height: 10px;\n        background: #666;\n        cursor: pointer;\n      }\n\n      &::-moz-range-thumb {\n        width: 10px;\n        height: 10px;\n        background: #666;\n        cursor: pointer;\n        border: none;\n      }\n    }\n\n    .zoom-percentage {\n      font-size: 11px;\n      color: #333;\n      min-width: 32px;\n      text-align: left;\n    }\n  }\n}\n\n// Mobile responsive\n@media (max-width: 768px) {\n  .zoom-controls-bottom {\n    bottom: 5px;\n    right: 10px;\n\n    .zoom-controls-container {\n      gap: 4px;\n\n      .zoom-btn {\n        width: 20px;\n        height: 20px;\n\n        i {\n          font-size: 8px;\n        }\n      }\n\n      .zoom-slider {\n        width: 70px;\n      }\n\n      .zoom-percentage {\n        font-size: 10px;\n        min-width: 28px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
